<template>
  <div
    class="interaction-hint"
    :class="{ 'interaction-hint--hidden': isInteracting }"
    @click="scrollDown"
  >
    <!-- TODO: directly use icon component here -->
    <component :is="iconComponent" class="interaction-hint__icon" :style="{ animation }" />
    <span class="interaction-hint__label">{{ label }}</span>
  </div>
</template>

<script>
import { gsap, ScrollToPlugin } from 'gsap/all';

const ICONS = {
  'arrows-down': () => import('../../assets/icons/arrows-down.svg?inline'),
  rotate: () => import('../../assets/icons/rotate.svg?inline'),
  swipe: () => import('../../assets/icons/swipe.svg?inline'),
};
gsap.registerPlugin(ScrollToPlugin);

export default {
  name: 'InteractionHint',

  props: {
    icon: {
      type: String,
      required: true,
      validator: icon => Object.keys(ICONS).includes(icon),
    },

    label: {
      type: String,
      required: true,
    },

    animationClass: {
      type: String,
      default: '',
    },

    interactionTimeout: {
      type: Number,
      default: undefined,
    },

    interactionTrigger: {
      type: [String, Number],
      default: undefined,
    },
  },

  data() {
    return {
      interactionTimeoutId: null,
      isInteracting: false,
    };
  },

  computed: {
    iconComponent() {
      return ICONS[this.icon];
    },

    animation() {
      if (!this.animationClass) return;
      return `${this.animationClass} 2s ease-in-out infinite`;
    },

    isInteractionTimeoutEnabled() {
      return this.interactionTimeout !== undefined;
    },
  },

  watch: {
    isInteractionTimeoutEnabled(isInteractionTimeoutEnabled) {
      if (isInteractionTimeoutEnabled) return;

      clearTimeout(this.interactionTimeoutId);
      this.interactionTimeoutId = undefined;
    },

    interactionTrigger: {
      immediate: false,
      handler(interactionTrigger) {
        if (
          interactionTrigger === undefined ||
          interactionTrigger === null ||
          !this.isInteractionTimeoutEnabled
        )
          return;

        this.isInteracting = true;
        clearTimeout(this.interactionTimeoutId);

        this.interactionTimeoutId = setTimeout(() => {
          this.isInteracting = false;
        }, this.interactionTimeout);
      },
    },
  },

  methods: {
    scrollDown() {
      gsap.to(window, 2.5, { scrollTo: { y: 'max' } });
    },
  },
};
</script>

<style lang="scss" scoped>
.interaction-hint {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 220px;
  transition: opacity 0.2s ease;
}

.interaction-hint--hidden {
  opacity: 0;
  pointer-events: none;
}

.interaction-hint__label {
  font-size: 12px;
  text-align: center;
}

$icon-size: 30px;
.interaction-hint__icon {
  width: $icon-size;
  height: $icon-size;
  margin-bottom: 10px;
}
</style>
